// extracted by mini-css-extract-plugin
export default {"main":"CompactDraftList_main__SPP8q","buttonLink":"CompactDraftList_buttonLink__d0Bcb"};